export default __webpack_public_path__ + "static/media/Image023.14f9d850.jpg";